<!-- 新品模板库文件明细  资料库文件 -->
<template>
  <!-- 新品模板库文件明细 -->
  <h-inspection-page :title="h_i18n('869d895592a6bc276fd716de5097ad5d')" class="DetailTemplate_style" @inspection-update="inspectionUpdate">
    <!-- 新品模板库文件明细 -->
    <form-header :title="h_i18n('869d895592a6bc276fd716de5097ad5d')" title-height="80px" style="margin-top:8px;" v-loading="loading">
      <template #body>
        <!-- 模板库属性 -->
        <h-tr>{{ h_i18n('eda1ed64d0b056b855397956d73f02c4') }}</h-tr>
        <tr v-if="getData.queryFlag == 'film'">
          <!-- 大类；盘膜 -->
          <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('e86da95db59395cf9770af483fde29b5') }}</report-td>
          <!-- 材质 -->
          <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
          <!-- 胶型 -->
          <report-td :title="h_i18n('5f84a2040ec3476882e06ed9baec08e3')" colspan="4:4">{{ getData.model.glue }}</report-td>
        </tr>
        <tr v-if="getData.queryFlag == 'film'">
          <!-- 模板库ID -->
          <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:20">{{ getData.templetId }}</report-td>
        </tr>
        <tr v-if="getData.queryFlag == 'instruc'">
          <!-- 大类；说明书 -->
          <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('1f08ac8f42c807aa697b5c721dd69165') }}</report-td>
          <!-- 颜色 -->
          <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" colspan="4:4">{{ getData.model.colorOne }}</report-td>
          <!-- 模板库ID -->
           <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:4">{{ getData.templetId }}</report-td>
        </tr>
        <tr v-if="getData.queryFlag == 'pop'">
          <!-- 大类 -->
          <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">POP</report-td>
          <!-- 材质 -->
          <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.typeOne }}</report-td>
           <!-- 模板库ID -->
          <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:4">{{ getData.templetId }}</report-td>
        </tr>
        <tr v-if="getData.queryFlag == 'sticker'">
          <!-- 大类；不干胶贴 -->
          <report-td :title="h_i18n('d196c72826e21cb830aad6aed32478db')" colspan="4:4">{{ h_i18n('cc14f91613bf7e8f816ff7a6a825e1c2') }}</report-td>
          <!-- 材质 -->
          <report-td :title="h_i18n('e3623348d276b8fa54e772581fac9cae')" colspan="4:4">{{ getData.model.material }}</report-td>
          <!-- 颜色 -->
          <report-td :title="h_i18n('6b36c6f7ec834692ec6c8e3816349fdd')" colspan="4:4">{{ getData.model.color }}</report-td>
        </tr>
        <tr v-if="getData.queryFlag == 'sticker'">
          <!-- 工艺 -->
          <report-td :title="h_i18n('ec9875c10f408999de612355983da20c')" colspan="4:4">{{ getData.model.technology }}</report-td>
          <!-- 用途 -->
          <report-td :title="h_i18n('9c5d49bda7000887a8d10670ef1b1ed7')" colspan="4:4">{{ getData.model.bakOne }}</report-td>
           <!-- 模板库ID -->
          <report-td :title="h_i18n('d8861b4035e7616b0650b10f35282a8d')" colspan="4:4">{{ getData.templetId }}</report-td>
        </tr>
        <!-- 文件审核 -->
        <h-tr>{{ h_i18n('79a63d3eb8a197bd61b470fbab1c86ce') }}</h-tr>
        <tr>
          <!-- 供应商代码 -->
          <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="4:4">{{ getData.supplyCode }}</report-td>
          <!-- 供应商名称 -->
          <report-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="4:4">{{ getData.supplyName }}</report-td>
          <!-- 供方检验资格 -->
          <report-td :title="h_i18n('73ad4acf69901d02a25654178709e679')" colspan="4:4">{{ getData.supplyCheckLevelName }}</report-td>
        </tr>
        <tr>
          <!-- 工厂小微 -->
          <report-td :title="h_i18n('03490f3868798323211aa633194df2c1')" colspan="4:4">{{ getData.sybName }}</report-td>
          <!-- 专用号 -->
          <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="4:4">{{ getData.mtlNo }}</report-td>
          <!-- 物料名称 -->
          <report-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="4:4">{{ getData.mtlName }}</report-td>
        </tr>
        <tr>
          <!-- 物料大类 -->
          <report-td :title="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" colspan="4:20">{{ getData.materielCategoryName }}</report-td>
        </tr>
        <!-- 报告信息 -->
        <h-tr>{{ h_i18n('3075e304a94a1e5bf8ef4ff07fdd9fcd') }}</h-tr>
        <tr class="info_table_style">
          <!-- 序号 -->
          <td colspan="2">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</td>
          <!-- 报告名称 -->
          <td colspan="6">{{ h_i18n('affac2ba884d0629f91b56fd97827e8b') }}</td>
          <!-- 是否必须 -->
          <td colspan="2">{{ h_i18n('603a2318abf247f1630a85069eb46c45') }}</td>
          <!-- 附件 -->
          <td colspan="10">{{ h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c') }}</td>
          <!-- 判定结果 -->
          <td colspan="4">{{ h_i18n('a1f04aa1d1b2382f3e0a7ce101cc67a0') }}</td>
        </tr>
        <template v-for="(item,index) in getData.documentList" :key="item.templetid">
          <tr class="info_table_body_style">
            <td colspan="2">{{ index + 1}}</td>
            <td colspan="6">{{ item.documentName }}</td>
            <td colspan="2">
              <span v-if="item.isNeed == 'Y'" class="dangerColor">*</span>
            </td>
            <td colspan="10">
              <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block"
               @click="download(item.fileId,item.fileName)">{{ item.fileName }}</span>
            </td>
            <td colspan="4">
              <!-- 不合格 -->
              <span v-if="item.conclusion == 'F'" class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <!-- 合格 -->
              <span v-if="item.conclusion == 'P'" class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            </td>
          </tr>
        </template>
        <tr>
          <!-- 文件确认结论 -->
          <report-td :title="h_i18n('602ea77cb22627b55c86b34b9a3cf388')" colspan="4:20">{{ getData.rsContent }}</report-td>
        </tr>
        <tr>
          <!-- 所检项目 -->
          <report-td :title="h_i18n('0c3f86e6cee780592fa655ce154971f1')" colspan="4:20">
            <!-- 合格 -->
            <span v-if="getData.checkDocument == 'P'" class="successColor">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <!-- 不合格 -->
            <span v-if="getData.checkDocument == 'F'" class="dangerColor">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
          </report-td>
        </tr>
        <tr>
          <!-- <report-td :title="h_i18n('53d10cd0259c46a7a93a18842fb16fc8')" colspan="4:8">{{ getData.supplyCheckApprovorName }}</report-td> -->
          <!-- 确认时间 -->
          <report-td :title="h_i18n('df713dfbe610b926ac70234219f1230b')" colspan="4:8">{{ time(getData.supplyCheckApproveDate,6) }}</report-td>
          <!-- 审核时间 -->
          <report-td :title="h_i18n('e6f0708789d7efc02f1a163224ae7fb0')" colspan="4:8">{{ time(getData.validateDate,6) }}</report-td>
        </tr>
        <tr>
          <!-- <report-td :title="h_i18n('ca663fd1a51a779d74e8c9d6544374e8')" colspan="4:8">{{ getData.wjAuditingManName }}</report-td> -->
        </tr>
      </template>
      <div style="height: 100px">
        <h-button-group align="center">
          <!-- 返回 -->
          <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </form-header>
  </h-inspection-page>
</template>



<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  data() {
    return{
      source:null,
      countall: 0 ,//总数量
      back: 0 , // 不合格
      getData:{
        model:{}
      },
      auditFlag:{
        supplyCheckMark:false,
      },
      subLoading:false,
      auditData:{},
    }
  },
  methods:{
    h_i18n,
    inspectionUpdate(){
      this.postThisPageHeight()
    },
    
  /**
   * 文件下载
   */
    download(uuid,fileName){
      console.log('uuid',uuid)
      // 文件下载中...
      this.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'))
      if(uuid && uuid.includes("http")){
        this.httpFile({
          method: "get",
          url: this.$filePathSplicing(uuid),
          headers: {'content-type': 'application/json'},
        }, fileName)
      }else{
        this.httpFile({
          method: "get",
          url: this.$filePathSplicing(uuid),
          headers: {'content-type': 'application/json'},
        }, fileName)
      }
    },
    getDateInfo(patternPlanId){
      this.$http({
        url:'/base/newProductTemplet/searchSupplierTempletSelfCheckDetail?patternPlanId='+patternPlanId,
        method:'get',
      }).then(res=>{
        // console.log(res.data.data.postDTO.documentList)
        this.getData = res.data.data.patternPlan
        this.getData.documentList = res.data.data.postDTO.documentList
        this.getData.queryFlag = res.data.data.postDTO.model.queryFlag
        this.getData.model = res.data.data.postDTO.model
        this.getData.rsContent = res.data.data.rsContent
        this.countall = this.getData.documentList.length
        // 合格
        this.auditData.auditcheck = h_i18n('86f720320b77bb62311f0a4811db04fe')
        this.auditData.auditTime = this.time(new Date())
      })
    }
  },
  mounted(){
    if(this.$route.query.patternPlanId){
      this.getDateInfo(this.$route.query.patternPlanId)
    }else{
      this.info({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            // 暂无数据
            message: h_i18n('21efd88b67a39834582ad99aabb9dc60'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.$router.back();
            },
          });
    }
    if (this.$route.query.name || this.$route.query.nickName) {
      window.getItemName = this.$route.query.name
      window.getItemNickName = this.$route.query.nickName
    }
    if(this.$route.query.data){
      this.getData = JSON.parse(this.$route.query.data)
    }
  }
}
</script>

<style lang="scss">
.DetailTemplate_style{
  .input_rows_style {
    font-size: 16px !important;
    height: auto;

    .el-textarea__inner {
      height: auto;
    }
  }
  .info_table_style td {
      height:41px;
      font-size:14px;
      color:#666;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      text-align:center;
      background: #FAFAFA;
    
  }
  .info_table_body_style td {
    height:41px;
    font-size:14px;
    color:#666;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    text-align:center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &:hover {
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>